import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";

export const VideoModal = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="commons-video-modal" className="max-w-[min(1200px,94vw)] p-0 overflow-hidden bg-ink-deep border-ink-deep">
      <div className="px-6 pt-5 pb-4 text-white">
        <DialogTitle className="font-display text-2xl font-normal">Murrieta Family Commons</DialogTitle>
        <DialogDescription className="text-white/55 text-xs font-mono tracking-[0.16em] uppercase mt-1">Concept video · conceptual, not an approved site plan</DialogDescription>
      </div>
      {open && (
        <video
          data-testid="commons-video-player"
          src="/video/commons.mp4"
          controls
          autoPlay
          playsInline
          className="w-full max-h-[78vh] bg-black"
        />
      )}
    </DialogContent>
  </Dialog>
);
